import { useRef, useCallback } from 'react';

const useScrollingRef = (loading, hasMore, setPageNumber) => {
  const observer = useRef();
  const loadingElement = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, setPageNumber]
  );

  return loadingElement;
};

export default useScrollingRef;
